<template>

    <div v-if="!requisicoes.finalizado" class="loading-overlay">
        <div class="spinner"></div>
    </div>


    <div v-if="requisicoes.finalizado">

        <div class="title">
            <h3>Os campos com * são de preenchimento obrigatório</h3>
            <h5>Caso queira, você poderá salvar e continuar depois.</h5>
        </div>

        <div class="formulario">
            <div class="agrupamentoFormulario">
                <div class="categoriaAgrupamentoFormulario">
                    <LabelDisclaimer :TamanhoFonteLabel="'H5'" :NomeLabel="'Documentos'"
                        :TipoCliente="'Pessoa Jurídica'" :Sessao="'Documentos'" :SubSessao="'Documentos'" />
                    <span>Todos os arquivos marcados como obrigatórios, deverão ser anexados</span>
                </div>
                <div class="camposAgrupamentoFormulario">
                    <div class="row">
                        <div class="label__field" style="width: 80%">
                            <label class="label" for="nome">Tipo de documento*</label>

                            <div style="display: inline-flex; width: 100%">
                                <select id="tipoCadastro"
                                    style="width: 30%; height: 38px; margin-right: 20px;" class="field"
                                    v-model="TipoDocumento">
                                    <option value="">Selecione</option>
                                    <option v-for="item in listaDocumentosFiltrados" :key="item.Id" :value="item.Id">
                                        <span :style="{ background: item.Obrigatorio ? 'red' : 'none' }">{{ item.Nome
                                            }}{{ item.Obrigatorio == 'Sim' ? ' - Obrigatório' : '' }}</span>
                                    </option>
                                </select>


                                <div v-for="(documento, index) in listaDocumentosFiltradosComTipo" :key="index">
                                    <div class="label__field" style="width: 80%">
                                        <!-- Atributos específicos para melhorar compatibilidade com Safari iOS -->
                                        <input type="file" 
                                            :id="'fileInput' + index" 
                                            :ref="'fileInput' + index"
                                            accept="image/*,application/pdf"
                                            style="display: none" 
                                            @change="handleFileChange($event, documento.Id)">
                                        
                                        <!-- Botão para acionar o input file -->
                                        <button class="btnBlueUpload" 
                                                :style="getDocumentoStyle()"
                                                @click.prevent="triggerFileInput(index)">
                                            Anexar arquivo
                                        </button>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>








                </div>
            </div>


            <div style="margin-top: 30px;">

                <div class="formulario">

                    <div class="resumoForm">

                        <div class="grid-desktop">
                            <table class="table">
                                <thead>
                                    <th style="width: 15%">Tipo de documento</th>
                                    <th style="width: 15%">Nome do arquivo</th>
                                    <th style="width: 15%">Data/Hora</th>
                                    <th style="width: 10%">Ações</th>
                                </thead>
                                <tbody v-if="requisicoes.listaDocumentosUploadEfetuado">
                                    <tr v-for="(arquivo, index) in arquivos" :key="index">
                                        <td>{{ getNomeDoDocumento(arquivo.TipoDocumentoId) }}</td>
                                        <td>{{ arquivo.FileName }}</td>
                                        <td>{{
                                            formatDateTime(arquivo.InsertDate)}}
                                        </td>
                                        <td>

                                            <div class="widget icons produtos" style="display: inline-flex; ">

                                                <a @click.stop.prevent="excluirArquivo(arquivo, index)" 
                                                    title="Deletar arquivo" 
                                                    v-if="!Edicao" 
                                                    :class="{ 'disabled': deletando == index }"
                                                    style="margin-left: 5px; position: relative; display: inline-block;">
                                                    <i class="ico__delete" v-if="deletando != index" style="display: inline-block;"></i>
                                                    
                                                    <i v-if="deletando == index" class="loading-spinner-button" style="display: inline-block;"></i>
                                                </a>

                                            </div> 

                                        </td>
                                    </tr>
                                </tbody>

                                 <tbody v-if="!requisicoes.listaDocumentosUploadEfetuado">
                                    <tr v-for="(arquivo, index) in arquivos" :key="index">
                                        <td>{{ getNomeDoDocumento(arquivo.TipoDocumentoId) }}</td>
                                        <td>{{ arquivo.FileName }}</td>
                                        <td>{{
                                            formatDateTime(arquivo.InsertDate)}}
                                        </td>
                                        <td></td>
                                    </tr>
                                    <tr v-for="i in 1" :key="'loading-'+i" class="loading-row">
                                        <td colspan="4"><div class="shimmer"></div></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        
                        <!-- Versão mobile da grid -->
                        <div class="grid-mobile" style="display: none">
                            <div class="rows__carteiras">
                                <div class="header__row">
                                    <div class="widget">
                                        <p>Tipo de documento</p>
                                    </div>
                                    
                                    <div class="widget">
                                        <p>Nome do arquivo</p>
                                    </div>
                                    
                                    <div class="widget">
                                        <p>Data/Hora</p>
                                    </div>
                                </div>
                                
                                <!-- Conteúdo para quando os documentos já foram carregados -->
                                <div v-if="requisicoes.listaDocumentosUploadEfetuado">
                                    <div v-for="(arquivo, index) in arquivos" :key="index"
                                        class="row__client">
                                        <div class="info__client">                                
                                            <div class="widget">
                                                <p class="title__mobile">Tipo de documento</p>
                                                <p>{{ getNomeDoDocumento(arquivo.TipoDocumentoId) }}</p>
                                            </div>
                                            
                                            <div class="widget">
                                                <p class="title__mobile">Nome do arquivo</p>
                                                <p>{{ arquivo.FileName }}</p>
                                            </div>
                                            
                                            <div class="widget">
                                                <p class="title__mobile">Data/Hora</p>
                                                <p>{{ formatDateTime(arquivo.InsertDate) }}</p>
                                            </div>
                                            
                                            <div class="widget icons" v-if="!Edicao" style="display: inline-flex">
                                                <a @click.stop.prevent="excluirArquivo(arquivo, index)" 
                                                    title="Deletar arquivo" 
                                                    :class="{ 'disabled': deletando == index }"
                                                    style="margin-left: 5px; position: relative; display: inline-block;">
                                                    <i class="ico__delete" v-if="deletando != index" style="display: inline-block;"></i>
                                                    <i v-if="deletando == index" class="loading-spinner-button" style="display: inline-block;"></i>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                                <!-- Conteúdo para carregamento inicial -->
                                <div v-if="!requisicoes.listaDocumentosUploadEfetuado">
                                    <div v-for="(arquivo, index) in arquivos" :key="index"
                                        class="row__client">
                                        <div class="info__client">                                
                                            <div class="widget">
                                                <p class="title__mobile">Tipo de documento</p>
                                                <p>{{ getNomeDoDocumento(arquivo.TipoDocumentoId) }}</p>
                                            </div>
                                            
                                            <div class="widget">
                                                <p class="title__mobile">Nome do arquivo</p>
                                                <p>{{ arquivo.FileName }}</p>
                                            </div>
                                            
                                            <div class="widget">
                                                <p class="title__mobile">Data/Hora</p>
                                                <p>{{ formatDateTime(arquivo.InsertDate) }}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="shimmer"></div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>


        </div>

    </div>
</template>


<script>

import api from '@/api/axios';
import { mapGetters } from 'vuex';
import formatData from '@/utils/formatData';
import LabelDisclaimer from '../Utilitarios/Disclaimer/LabelDisclaimer.vue'

export default {
    mixins: [formatData],
    components: { LabelDisclaimer },
    name: 'CadastroPF_UploadDocumentos',
    props: ['Edicao'],
    computed: {
        ...mapGetters({
            user: 'auth/user',
            listaDocumentos: 'GET_LISTA_DOCUMENTOS_UPLOAD',
            listaDocumentosUploadEfetuado: 'GET_LISTA_DOCUMENTOS_UPLOAD_REALIZADO'
        }),
        listaDocumentosFiltrados() {
            return this.listaDocumentos.filter(
                documento => documento.TipoCliente === 'Pessoa Jurídica' || documento.TipoCliente === 'Todos'
            );
        },
        listaDocumentosFiltradosComTipo() {
            return this.listaDocumentos.filter(
                documento => (documento.TipoCliente === 'Pessoa Jurídica' || documento.TipoCliente === 'Todos') && documento.Id == this.TipoDocumento
            );
        },
    },
    data() {
        return {
            permitirAvancar: false,
            TipoDocumento: "",
            deletando: -1,
            requisicoes: {
                listaDocumentos: false,
                listaDocumentosUploadEfetuado: false,
                finalizado: false
            },
            arquivosUpload: [],
            arquivos: [],
            arquivo: {
                ClienteId: null,
                TipoDocumentoId: '',
                FileName: '',
                Descricao: '',
                FileDataString64: '',
                UsuarioInsert: '',
                Data: new Date()
            },
        }
    },
    created() {
        this.$store.dispatch('FETCH_CONSULTA_LISTA_DOCUMENTOS_UPLOAD');
        this.$store.dispatch('FETCH_CONSULTA_LISTA_DOCUMENTOS_UPLOAD_REALIZADO', this.user.ClienteId);

    },
    mounted() {
        this.executarListagemUploads();
    },
    watch: {
        listaDocumentosUploadEfetuado() {
            this.executarListagemUploads();
        },
        listaDocumentos() {
            this.verificarSeRequisicoesFinalizaram('listaDocumentos')
        }
    },
    methods: {
        executarListagemUploads(){
            this.verificarSeRequisicoesFinalizaram('listaDocumentos');
            this.verificarSeRequisicoesFinalizaram('listaDocumentosUploadEfetuado');
            if (this.listaDocumentosUploadEfetuado != null) {
                this.arquivosUpload = [];
                this.arquivos = this.listaDocumentosUploadEfetuado;
            }
            this.validarFormulario();
        },
        verificarSeRequisicoesFinalizaram(requisicao) {
            if (requisicao == 'listaDocumentos') {
                this.requisicoes.listaDocumentos = true;
            } else if (requisicao == 'listaDocumentosUploadEfetuado') {
                this.requisicoes.listaDocumentosUploadEfetuado = true;
            }

            if (this.requisicoes.listaDocumentosUploadEfetuado && this.requisicoes.listaDocumentos) {
                this.requisicoes.finalizado = true;
            }
        },
        getNomeDoDocumento(tipoDocumentoId) {
            const documento = this.listaDocumentos.find(doc => doc.Id === tipoDocumentoId);
            return documento ? documento.Nome : 'Documento não encontrado';
        },
        validarFormulario(submeter) {
            this.permitirAvancar = true;
            var nomeDoCampo = '';

            this.listaDocumentos.forEach(obj => {
                if ((obj.TipoCliente == 'Pessoa Jurídica' || obj.TipoCliente == 'Todos') && obj.Obrigatorio == 'Sim') {
                    if (!this.arquivos.some(arquivo => arquivo.TipoDocumentoId === obj.Id)) {
                        if (this.permitirAvancar) {
                            nomeDoCampo = obj.Nome;
                        }
                        this.permitirAvancar = false;
                    }
                }

            });


            if (submeter && nomeDoCampo != '') {
                this.$swal({
                    icon: 'warning',
                    title: 'Oops...',
                    text: `O documento ` + nomeDoCampo + ` é obrigatório e não foi enviado, envie o documento para avançar`,
                });
            }

        },
        proximaEtapa() {
            this.validarFormulario(true);
            if (this.permitirAvancar) {
                this.$store.commit('SET_SALVAR_INFO_DES_NOTIFICACAO', true);
                this.$store.commit('SET_PJ_SALVAR_INFO', true);
                this.$store.commit('SET_ETAPA_CADASTRO', 7);
            }
            
        },
        triggerFileInput(index) {
            // Garantir que o elemento existe
            if (!this.$refs['fileInput' + index] || !this.$refs['fileInput' + index][0]) {
                return;
            }
            
            const fileInput = this.$refs['fileInput' + index][0];
            
            // Para iOS Safari, precisamos garantir que o input esteja visível durante o clique
            const originalDisplay = fileInput.style.display;
            fileInput.style.display = 'block';
            fileInput.style.position = 'absolute';
            fileInput.style.opacity = '0.01';
            fileInput.style.zIndex = '9999';
            
            // Usando um timeout pequeno para garantir que o DOM foi atualizado
            setTimeout(() => {
                // Simulando um toque/clique nativo para melhor compatibilidade com iOS
                const event = new MouseEvent('click', {
                    view: window,
                    bubbles: true,
                    cancelable: true
                });
                fileInput.dispatchEvent(event);
                
                // Restaurar a exibição original após outro pequeno delay
                setTimeout(() => {
                    fileInput.style.display = originalDisplay;
                }, 200);
            }, 50);
        },
        getDocumentoStyle() {
            return {
                color: 'white',
                backgroundColor: '#00235C',
                border: '1px solid #00235C'
            };
        },
        async excluirArquivo(arquivo, index) {
             
            this.deletando = index;

            await api.post(`/cliente/documentos/excluir`, arquivo)
                .then((retorno) => {
                    this.deletando = -1;

                    if (retorno.status == 200) {

                        this.$store.dispatch('FETCH_CONSULTA_LISTA_DOCUMENTOS_UPLOAD_REALIZADO', this.user.ClienteId);

                        this.$swal({
                            icon: 'success',
                            title: 'Exclusão realizada com sucesso!',
                            text: 'Arquivo informado foi excluído.',
                        });

                        this.validarFormulario();
                    }else{
                      this.$swal({
                        icon: 'error',
                        title: 'Erro',
                        text: `Falha ao realizar exclusão do arquivo.`,
                        });
                    }
                })
                .catch((error) => {
                    this.deletando = -1;
                    this.$swal({
                        icon: 'error',
                        title: 'Falha ao realizar exclusão do arquivo.',
                        text: `${error.response.data.data[0]}`,
                    });
                });

            this.validarFormulario();

        },
        salvarAlteracoesLocalmente() {
            this.$store.commit('SET_SALVAR_INFO_UPLOAD', this.arquivosUpload);
            this.validarFormulario();
            this.requisicoes.listaDocumentosUploadEfetuado = false;
            this.$store.commit('SET_SALVAR_INFO_DES_NOTIFICACAO', true);
            this.salvar();
        },
        salvar() {
            this.$store.commit('SET_PJ_SALVAR_INFO', true);
        },
        handleFileChange(event, id) {
            const file = event.target.files[0];
            if (!file) {
                console.error('Nenhum arquivo selecionado');
                return;
            }
            
            // Salvando informações do arquivo para referência
            const fileName = file.name;
            // Verificar tipo e tamanho do arquivo antes de prosseguir
            // Opcional: adicione suas verificações de validação aqui
            
            const reader = new FileReader();
            
            // Manipuladores de eventos para capturar erros
            reader.onerror = (error) => {
                console.error('Erro ao ler o arquivo:', error);
                this.$swal({
                    icon: 'error',
                    title: 'Erro no upload',
                    text: 'Houve um problema ao processar o arquivo. Por favor, tente novamente.',
                });
            };
            
            reader.onabort = () => {
                console.warn('Leitura de arquivo cancelada');
            };
            
            reader.onload = (e) => {
                try {
                    const base64String = e.target.result;
                    // Verificar se o resultado é uma string válida
                    if (typeof base64String !== 'string') {
                        throw new Error('Resultado inválido da leitura do arquivo');
                    }
                    
                    // Remover o prefixo "data:*/*;base64," se presente
                    let base64Data = base64String;
                    if (base64String.includes(',')) {
                        base64Data = base64String.split(',')[1];
                    }
                    
                    // Criar objeto de arquivo com os dados necessários
                    this.novoArquivo = {
                        ClienteId: this.user.ClienteId,
                        TipoDocumentoId: id,
                        FileName: fileName,
                        Descricao: '',
                        FileDataString64: base64Data,
                        UsuarioInsert: this.user.NomeRazaoSocial,
                        // Adicionar timestamp para evitar problemas de cache
                        timestamp: new Date().getTime()
                    };
                    
                    // Adicionar ao array de uploads e limpar seleção
                    this.arquivosUpload.push({ ...this.novoArquivo });
                    this.TipoDocumento = '';
                    this.salvarAlteracoesLocalmente();

                } catch (error) {
                    console.error('Erro ao processar arquivo:', error);
                    this.$swal({
                        icon: 'error',
                        title: 'Erro no processamento',
                        text: 'Não foi possível processar o arquivo selecionado.',
                    });
                }
            };
            
            // Usar setTimeout para evitar problemas de timing no Safari iOS
            setTimeout(() => {
                // Tentar ler como DataURL para garantir melhor compatibilidade com Safari
                reader.readAsDataURL(file);
            }, 100);
            
            // Limpar o input para permitir a seleção do mesmo arquivo novamente
            // Usar setTimeout para evitar problemas de timing no Safari
            setTimeout(() => {
                event.target.value = null;
            }, 200);
        }
    }
}

</script>


<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap');

.btnBlueUpload {
    height: 40px;
    font-family: 'Inter', sans-serif;
    border-radius: 8px;
    min-width: 120px; /* Definir largura mínima para facilitar toque */
    padding: 0 16px;  /* Adicionar padding horizontal */
    cursor: pointer;
    -webkit-appearance: none; /* Remover aparência padrão no iOS */
    -webkit-tap-highlight-color: transparent; /* Remover highlight de toque no iOS */
    touch-action: manipulation; /* Otimizar para toque */
}

@supports (-webkit-touch-callout: none) {
    /* CSS específico para iOS Safari */
    .camposAgrupamentoFormulario .row {
        flex-wrap: wrap; /* Permitir quebra de linha */
    }
    
    .label__field {
        width: 100% !important; /* Garantir largura completa em telas pequenas */
        padding-right: 0; /* Remover padding direito em telas pequenas */
        margin-bottom: 10px; /* Adicionar espaço vertical */
    }
    
    select {
        -webkit-appearance: none; /* Remover aparência padrão no iOS */
        appearance: none;
        background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%23667085' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'/%3E%3C/svg%3E");
        background-repeat: no-repeat;
        background-position: right 12px center;
        padding-right: 40px; /* Espaço para o ícone */
    }
}

.btnBlueUpload:active {
    opacity: 0.8;
    transform: scale(0.98);
}


.formulario {
    width: 100%;
}

.agrupamentoFormulario {
    width: 100%;
    display: inline-flex;
    margin-top: 10px;
}

.categoriaAgrupamentoFormulario {
    width: 13%;
    margin-right: 15px;
    font-family: 'Inter', sans-serif;
    /* Fonte Inter */

    span {
        font-weight: 400 !important;
        font-size: 13px;
        color: #667085;
    }

}

.label__field {
    padding-right: 30px;
}

.camposAgrupamentoFormulario {
    width: 90%;

    .row {
        width: 100%;
        display: inline-flex;
        gap: 8px;
        margin-bottom: 10px;
    }

    .accept {
        display: inline-flex;

        &:checked {
            +label {
                &:before {
                    background: white;
                    border: 1px solid black;
                    transition: background 0.3s;
                }
            }

            +label {
                &::after {
                    opacity: 1;
                    transition: all;
                    background: transparent;
                }
            }
        }
    }



    .radio {
        display: flex;
        align-items: center;
        margin-right: 25px;

        @media (max-width: 768px) {
            margin-right: 0;
            margin-bottom: 20px;
        }

        .field__radio {
            width: 20px;
            height: 20px;
        }

        .fieldInRadio {
            border-radius: 8px;
            /* Raio de borda */
            border: 1px solid #D0D5DD;
            /* Borda */
            padding: 10px 14px;
            /* Preenchimento interno */
            background-color: #F9FAFB;
            /* Cor de fundo */
            width: 55%;
        }

        .label__radio {
            margin-left: 5px;
            margin-right: 40px;
            margin-top: 5px;
        }
    }

    select {
        width: 105% !important;
    }


    label {
        font-family: 'Inter', sans-serif;
        /* Fonte Inter */
        font-weight: 500;
        /* Peso médio */
        font-size: 14px;
        /* Tamanho da fonte */
        line-height: 20px;
        /* Altura da linha */
        color: #344054;
        /* Cor */
        display: block;
        /* Garante que a label fique acima do input */
        margin-bottom: 8px;
        /* Espaçamento entre a label e o input abaixo dela */
    }

}





.title {

    border-bottom: 1px solid #EAECF0;

    h3 {
        margin-top: 50px;
        color: #101828;
        font-weight: 500;
        font-family: 'Inter', sans-serif;

    }

    h5 {
        margin-top: 5px;
        margin-block-start: 0;
        color: #667085;
        font-weight: 400;
        font-family: 'Inter', sans-serif;
    }
}
</style>